import { useState } from 'react';
import type { MerchandiseItem } from '../api/merchandise';
import styles from './RechargeItemPicker.module.css';

interface RechargeItemPickerProps {
  item: MerchandiseItem;
  onQuantityChange: (item: MerchandiseItem, quantity: number) => void;
}

export function RechargeItemPicker({ item, onQuantityChange }: RechargeItemPickerProps) {
  const [quantity, setQuantity] = useState(0);

  const handleDecrease = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      onQuantityChange(item, newQuantity);
    }
  };

  const handleIncrease = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    onQuantityChange(item, newQuantity);
  };

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <span className={styles.name}>{item.name}</span>
        <span className={styles.price}>${(item.price / 100).toFixed(2)}</span>
      </div>
      <div className={styles.controls}>
        <button
          className={styles.button}
          onClick={handleDecrease}
          disabled={quantity === 0}
        >
          -
        </button>
        <span className={styles.quantity}>{quantity}</span>
        <button className={styles.button} onClick={handleIncrease}>
          +
        </button>
      </div>
    </div>
  );
}

export default RechargeItemPicker;
